import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'savedDataGridView';

const savedDataGridViewService = {
  getViews: (gridIdentifier) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}?gridIdentifier=${encodeURIComponent(gridIdentifier)}`,
    });
  },

  createView: (data) => {
    return request({
      method: Methods.POST,
      resource: baseURL,
      data,
    });
  },

  updateView: (id, data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },

  deleteView: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },
};

export default savedDataGridViewService;
